import { Injectable } from "@angular/core";
import { Weekday } from "../../domain/models/week-days";
import { WeekdayRepository } from "../../repositories/weekdays.repository";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";

@Injectable({ providedIn: 'root' })
export class GetWeekdayUsecase implements UseCase<null, Weekday[]> {

  constructor(private readonly weekdayRepository: WeekdayRepository) {
  }

  execute(): Observable<Weekday[]> {
    return this.weekdayRepository.getWeekdays();
  }

}
